import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class LegendsAPI extends ComponentAPI {
    /**
     * Gets the hide expression.
     */
    getHideExpression() {
        return this.state.hideExpression;
    }
    /**
     * Sets the hide expression.
     *
     * @param hideExpression - The hide expression
     */
    setHideExpression(hideExpression) {
        this.setState({ hideExpression });
    }
    /**
     * Gets the legends mode.
     */
    getMode() {
        return this.state.mode;
    }
    /**
     * Sets the legends mode.
     *
     * @param mode - The legends mode
     */
    setMode(mode) {
        this.setState({ mode });
    }
    /**
     * Gets the preview amount of legends.
     */
    getPreviewAmount() {
        return this.state.previewAmount;
    }
    /**
     * Sets the preview amount of legends.
     *
     * @param previewAmount - The preview amount of legends
     */
    setPreviewAmount(previewAmount) {
        this.setState({ previewAmount });
    }
    /**
     * Gets the show expression.
     */
    getShowExpression() {
        return this.state.showExpression;
    }
    /**
     * Sets the show expression.
     *
     * @param showExpression - The show expression
     */
    setShowExpression(showExpression) {
        this.setState({ showExpression });
    }
    /**
     * Checks if the preview is being shown.
     */
    getShowPreview() {
        return this.state.showPreview;
    }
    /**
     * Sets the show preview property.
     *
     * @param showPreview - If it should show the legends preview.
     */
    setShowPreview(showPreview) {
        this.setState({ showPreview });
    }
    /**
     * Gets the size of the legends.
     */
    getSize() {
        return this.state.size;
    }
    /**
     * Sets the size of the legends.
     *
     * @param size - The size of the legends
     */
    setSize(size) {
        this.setState({ size });
    }
}
export { LegendsAPI, };
//# sourceMappingURL=legends-api.js.map